import { ref } from 'vue';
import { apiClient } from '@/Clients/ApiClient.js';
import UserProfileService from '@/Services/UserProfileService.js';

export function useUserProfile() {
    const service = new UserProfileService(apiClient);
    const profile = ref(null);

    const loadProfile = (urlName) =>
        service.getProfile(urlName).then((response) => {
            profile.value = response.data;
            return profile.value;
        });

    return { service, profile, loadProfile };
}
